import { TimePeriod } from '@v2/pages/machines/common/enums';

// Min bar height (scale px) to show OEE % label in 8-week mode; below it the
// label collides with the bar's top edge / chart hairline.
export const OEE_LABEL_MIN_BAR_HEIGHT = 30;

// Per-bar moment unit within one page. Week/Month use the 'days' default.
export const BAR_STEP_UNIT: Partial<Record<TimePeriod, string>> = {
  [TimePeriod.DAY]: 'hours',
  [TimePeriod.YEAR]: 'months',
  [TimePeriod.EIGHT_WEEKS]: 'weeks',
};
